 import * as types from './mutations-types'
import {LOAD_TEMPLATE_KEY} from "./mutations-types";

export default {
 [types.SET_TICKET_TYPES](state, data) {
    state.eventTicketTypes = data
},

[types.ADD_TICKET_TYPE](state, newTicket) {
    state.eventTicketTypes.push(newTicket)
},

[types.UPDATE_TICKET_TYPE](state, updatedTicket) {
    const index = state.eventTicketTypes.findIndex(ticket => ticket.id === updatedTicket.id)
    if (index !== -1) {
        state.eventTicketTypes.splice(index, 1, updatedTicket)
    }
},

[types.DELETE_TICKET_TYPE](state, ticketId) {
    state.eventTicketTypes = state.eventTicketTypes.filter(ticket => ticket.id !== ticketId)
},
[types.SET_CURRENT_TICKET_TEMPLATE](state, templateData) {
        state.currentTicketTemplate = templateData
}

}
 
